import React from "react";
import DatePickerWindow from "./DatePickerWindow";
import RecordWaterTestResultForm from "../inventory/forms/RecordWaterTestResultForm";
import RenameWarehouseForm from "../inventory/forms/RenameWarehouseForm";
import RegisterWarehouseForm from "../inventory/forms/RegisterWarehouseForm";
import WarehouseAddressForm from "../inventory/forms/WarehouseAddressForm";
import WarehouseContactForm from "../inventory/forms/WarehouseContactForm";
import CreateProductForm from "../../inventory/products/forms/CreateProductFormContainer";
import ProductDescriptionForm from "../../inventory/products/forms/ProductDescriptionFormContainer";
import ProductBundleDescriptionForm from "../../inventory/products/forms/ProductBundleDescriptionFormContainer";
import CreateProductBundleForm from "../../inventory/products/forms/CreateProductBundleFormContainer";
import AddProductToBundleForm from "../../inventory/products/forms/AddProductToBundleFormContainer";
import AddProductToShopForm from "../../inventory/shops/forms/AddProductToShopFormContainer";
import RemoveProductFromShopForm from "../../inventory/shops/forms/RemoveProductFromShopFormContainer";
import ChangeProductPricingForm from "../../inventory/shops/forms/ChangeProductPricingFormContainer";
import ChangeSubscriptionProductPricingForm from "../../inventory/shops/forms/ChangeSubscriptionProductPricingFormContainer";
import CommitProductPricelistForm from "../../inventory/shops/forms/CommitProductPricelistFormContainer";
import CommitSubscriptionPricelistForm from "../../inventory/shops/forms/CommitSubscriptionPricelistFormContainer";
import ApplyProductSurchargeForm from "../../inventory/shops/forms/ApplyProductSurchargeFormContainer";
import EditProductSurchargeForm from "../../inventory/shops/forms/EditProductSurchargeFormContainer";
import ChangeAvailabilityForLocationForm from "../../inventory/shops/forms/ChangeAvailabilityForLocationFormContainer";
import RemoveProductFromBundleForm from "../../inventory/products/forms/RemoveProductFromBundleFormContainer";
import MeasurementsForm from "../../inventory/products/forms/MeasurementsFormContainer";
import SetOperationHoursForm from "../../inventory/warehouses/forms/SetOperationHoursFormContainer";
import AssignWarehouseBackupForm from "../../inventory/warehouses/forms/AssignWarehouseBackupFormContainer";
import ScanBarcodeForm from "../../inventory/warehouses/forms/ScanBarcodeFormContainer";
import OrderDetailForm from "../../inventory/warehouses/forms/OrderDetailFormContainer";

import AddStockForm from "../../inventory/stock/forms/AddStockFormContainer";
import RemoveStockForm from "../../inventory/stock/forms/RemoveStockFormContainer";

import RemoveProductForm from "../inventory/forms/RemoveProductForm";
import AssignWarehouseCourierForm from "../inventory/forms/AssignWarehouseCourierForm";

import SetAvailabilityForm from "../shipping/forms/SetAvailabilityForm";

import RegisterOtherPalletForm from "../../inventory/production/forms/RegisterOtherPalletFormContainer";
import ModifyOtherPalletForm from "../../inventory/production/forms/ModifyOtherPalletFormContainer";
import RejectWaterContainerForm from "../../inventory/production/forms/RejectWaterContainerFormContainer";
import AddWaterContainerToPalletForm from "../../inventory/production/forms/AddWaterContainerToPalletFormContainer";

import AddProductToCartForm from "../../customers/forms/AddProductToCartFormContainer";
import EditProductInCartForm from "../../customers/forms/EditProductInCartFormContainer";
import AddSubscriptionToCartForm from "../../customers/forms/AddSubscriptionToCartFormContainer";
import EditSubscriptionInCartForm from "../../customers/forms/EditSubscriptionInCartFormContainer";
import CreateCustomerForm from "../../customers/forms/CreateCustomerFormContainer";
import ChangeContactDetailsForm from "../../customers/forms/ChangeContactDetailsFormContainer";
import AddAccountForm from "../../customers/forms/AddAccountFormContainer";
import DeleteAccountForm from "../../customers/forms/DeleteAccountFormContainer";
import RenameAccountForm from "../../customers/forms/RenameAccountFormContainer";
import AssignReferralCodeForm from "../../customers/forms/AssignReferralCodeFormContainer";
import AssignAccountVipStatusForm from "../../customers/forms/AssignAccountVipStatusFormContainer";
import UnassignAccountVipStatusForm from "../../customers/forms/UnassignAccountVipStatusFormContainer";
import DeleteCustomerForm from "../../customers/forms/DeleteCustomerFormContainer";
import AddShippingAddressForm from "../../customers/forms/AddShippingAddressFormContainer";
import EditShippingAddressForm from "../../customers/forms/EditShippingAddressFormContainer";
import RemoveShippingAddressForm from "../../customers/forms/RemoveShippingAddressFormContainer";
import SetBillingAddressForm from "../../customers/forms/SetBillingAddressFormContainer";
import ChangeBillingAddressForm from "../../customers/forms/ChangeBillingAddressFormContainer";
import SetTaxInfoForm from "../../customers/forms/SetTaxInfoFormContainer";
import SetTaxExemptionForm from "../../customers/forms/SetTaxExemptionFormContainer";
// import ChangeBillingMethodForm from "../../customers/forms/ChangeBillingMethodFormContainer";
import SetPaymentTermsForm from "../../customers/forms/SetPaymentTermsFormContainer";
import SetPaymentCreditCardForm from "../../customers/forms/SetPaymentCreditCardFormContainer";
import ChangeBillingStatusForm from "../../customers/forms/ChangeBillingStatusFormContainer";
import RecordPaymentForm from "../../customers/forms/RecordPaymentFormContainer";
import CheckPaymentStatusForm from "../../customers/forms/CheckPaymentStatusFormContainer";
import RetryPaymentForm from "../../customers/forms/RetryPaymentFormContainer";
import ChangeSubscriptionFrequencyForm from "../../customers/forms/ChangeSubscriptionFrequencyFormContainer";
import Change8PackPreferenceForm from "../../customers/forms/Change8PackPreferenceFormContainer";
import ChangeSubscriptionQuantityForm from "../../customers/forms/ChangeSubscriptionQuantityFormContainer";
import ChangeSubscriptionProductsForm from "../../customers/forms/ChangeSubscriptionProductsFormContainer";
import ChangeSubscriptionShippingAddressForm from "../../customers/forms/ChangeSubscriptionShippingAddressFormContainer";
import RescheduleSubscriptionDeliveryForm from "../../customers/forms/RescheduleSubscriptionDeliveryFormContainer";
import NewSubscriptionShippingAddressForm from "../../customers/forms/NewSubscriptionShippingAddressFormContainer";
import ResumeSubscriptionSchedulingForm from "../../customers/forms/ResumeSubscriptionSchedulingFormContainer";
import PauseSubscriptionForm from "../../customers/forms/PauseSubscriptionFormContainer";
import CancelSubscriptionForm from "../../customers/forms/CancelSubscriptionFormContainer";
import RestartSubscriptionForm from "../../customers/forms/RestartSubscriptionFormContainer";
import RenameSubscriptionForm from "../../customers/forms/RenameSubscriptionFormContainer";
import AddCreditCardForm from "../../customers/forms/AddCreditCardFormContainer";
import ChangeCreditCardForm from "../../customers/forms/ChangeCreditCardFormContainer";
import RemoveCreditCardForm from "../../customers/forms/RemoveCreditCardFormContainer";
import AssignDefaultCreditCardForm from "../../customers/forms/AssignDefaultCreditCardFormContainer";
import ChangeCartPoliciesForm from "../../customers/forms/ChangeCartPoliciesFormContainer";
import ToggleMarketingCommunicationsForm from "../../customers/forms/ToggleMarketingCommunicationsFormContainer";

import ChargePaymentsView from "../../customers/views/ChargePaymentsView";
import SubscriptionLogView from "../../customers/views/SubscriptionLogView";
import SubscriptionDeliveryView from "../../customers/views/SubscriptionDeliveryView";

import CreateShippingOrderForm from "../../shipping/forms/CreateOrderFormContainer";
import ChangeDeliveryAddressForm from "../../shipping/forms/ChangeDeliveryAddressFormContainer";
import AddProductToShippingOrderForm from "../../shipping/forms/AddProductToOrderFormContainer";
import RemovePackageFromOrderForm from "../../shipping/forms/RemovePackageFromOrderFormContainer";
import ReplacePackagesForShippingOrderForm from "../../shipping/forms/ReplacePackagesForShippingOrderFormContainer";
import ChangePackageDeliveryStatusDeliveredForm from "../../shipping/forms/ChangePackageDeliveryStatusDeliveredFormContainer";
import ChangePackageDeliveryStatusPickedUpForm from "../../shipping/forms/ChangePackageDeliveryStatusPickedUpFormContainer";
import RequestStockReservationForm from "../../shipping/forms/RequestStockReservationFormContainer";
import RequestShippingQuoteForm from "../../shipping/forms/RequestShippingQuoteFormContainer";
import AcceptShippingQuoteForm from "../../shipping/forms/AcceptShippingQuoteFormContainer";
import VoidShippingQuoteForm from "../../shipping/forms/VoidShippingQuoteFormContainer";
import StartShipmentForm from "../../shipping/forms/StartShipmentFormContainer";
import HoldShipmentForm from "../../shipping/forms/HoldShipmentFormContainer";
import ReleaseShipmentHoldForm from "../../shipping/forms/ReleaseShipmentHoldFormContainer";
import AssignWarehouseToLocationForm from "../../shipping/forms/AssignWarehouseToLocationFormContainer";
import ChangeWarehouseForOrderForm from "../../shipping/forms/ChangeWarehouseForOrderFormContainer";
import AssignWarehouseToOrderForm from "../../shipping/forms/AssignWarehouseToOrderFormContainer";
import CancelShippingOrderForm from "../../shipping/forms/CancelShippingOrderFormContainer";
import ViewEdiMessageDataForm from "../../shipping/forms/ViewEdiMessageDataFormContainer";
import ScheduleShipmentForm from "../../shipping/forms/ScheduleShipmentFormContainer";
import UnscheduleShipmentForm from "../../shipping/forms/UnscheduleShipmentFormContainer";
import SetCourierDeliveryInstructionsForm from "../../shipping/forms/SetCourierDeliveryInstructionsFormContainer";
import MarkShipmentAsComplimentaryForm from "../../shipping/forms/MarkShipmentAsComplimentaryFormContainer";

import CancelSalesOrderForm from "../../sales/forms/CancelSalesOrderFormContainer";
import PromoCodeForm from "../../sales/forms/CreatePromoCodeFormContainer";
import EditPromoCodeForm from "../../sales/forms/EditPromoCodeFormContainer";
import MetaOrderHistoryForm from "../../sales/forms/MetaOrderHistoryFormContainer";
import MetaOrderCancellationForm from "../../sales/forms/MetaOrderCancellationFormContainer";
import MetaOrderRefundForm from "../../sales/forms/MetaOrderRefundFormContainer";
import VoidChargeForm from "../../sales/forms/VoidChargeFormContainer";

import CreateReferralCodeForm from "../../referrals/forms/CreateReferralCodeFormContainer";
import EditReferralCodeForm from "../../referrals/forms/EditReferralCodeFormContainer";

import ChangeUsTaxSettingForm from "../../settings/us_taxes/forms/ChangeUsTaxSettingFormContainer";
import StartServiceForm from "../../settings/services/forms/StartServiceFormContainer";
import StopServiceForm from "../../settings/services/forms/StopServiceFormContainer";
import RunServiceForm from "../../settings/services/forms/RunServiceFormContainer";

import StartDeliveryForm from "../../subscriptions/forms/StartDeliveryFormContainer";
import RetrySchedulingForm from "../../subscriptions/forms/RetrySchedulingFormContainer";
import RetryStockReservationForm from "../../subscriptions/forms/RetryStockReservationFormContainer";
import ChangeStockReservationWarehouseForm from "../../subscriptions/forms/ChangeStockReservationWarehouseFormContainer";

import ChangePasswordForm from "../../onboarding/forms/ChangePasswordFormContainer";
import InviteCustomerForm from "../../onboarding/forms/InviteCustomerFormContainer";
import ConsignmentCommandForm from "../../pages/consignmentsTracking/forms/ConsignmentCommandFormContainer";
import ConsignmentDetailsForm from "../../pages/consignmentsTracking/forms/ConsignmentDetailsFormContainer";
import CheckoutChangeShippingAddressForm from "../../checkout/forms/ChangeShippingAddressFormContainer";
import CheckoutEditShippingAddressForm from "../../checkout/forms/EditShippingAddressFormContainer";
import CheckoutAddShippingAddressForm from "../../checkout/forms/AddShippingAddressFormContainer";
import AddGiftMessageForm from "../../checkout/forms/AddGiftMessageFormContainer";
import EditGiftMessageForm from "../../checkout/forms/EditGiftMessageFormContainer";
import RemoveGiftMessageForm from "../../checkout/forms/RemoveGiftMessageFormContainer";
import CancelCheckoutForm from "../../checkout/forms/CancelCheckoutFormContainer";
import PlaceOrderForm from "../../checkout/forms/PlaceOrderFormContainer";

import CreateNoteForm from "../../notes/forms/CreateNoteFormContainer";
import EditNoteForm from "../../notes/forms/EditNoteFormContainer";
import DeleteNoteForm from "../../notes/forms/DeleteNoteFormContainer";

import ErrorWindowView from "../views/ErrorWindowView";

export function buildWindowContent(kind, id, payload) {
  switch(kind) {

    case "DatePickerWindow":
      return build(DatePickerWindow, id, payload);

    case "ChangeUsTaxSettingWindow":
      return build(ChangeUsTaxSettingForm, id, payload);

    case "CancelShippingOrderWindow":
      return build(CancelShippingOrderForm, id, payload);

    case "ViewEdiMessageDataWindow":
      return build(ViewEdiMessageDataForm, id, payload);

    case "ScheduleShipmentWindow":
      return build(ScheduleShipmentForm, id, payload);

    case "UnscheduleShipmentWindow":
      return build(UnscheduleShipmentForm, id, payload);

    case "SetCourierDeliveryInstructionsWindow":
      return build(SetCourierDeliveryInstructionsForm, id, payload);

    case "MarkShipmentAsComplimentaryWindow":
      return build(MarkShipmentAsComplimentaryForm, id, payload);

    case "StartShipmentWindow":
      return build(StartShipmentForm, id, payload);

    case "HoldShipmentWindow":
      return build(HoldShipmentForm, id, payload);

    case "ReleaseShipmentHoldWindow":
      return build(ReleaseShipmentHoldForm, id, payload);

    case "CreateShippingOrderWindow":
      return build(CreateShippingOrderForm, id, payload);

    case "ChangeShippingOrderDeliveryAddressWindow":
      return build(ChangeDeliveryAddressForm, id, payload);

    case "AddProductToShippingOrderWindow":
      return build(AddProductToShippingOrderForm, id, payload);

    case "RemovePackageFromShippingOrderWindow":
      return build(RemovePackageFromOrderForm, id, payload);
    
    case "ReplacePackagesForShippingOrderWindow":
      return build(ReplacePackagesForShippingOrderForm, id, payload);

    case "ChangePackageDeliveryStatusDeliveredWindow":
      return build(ChangePackageDeliveryStatusDeliveredForm, id, payload);

    case "ChangePackageDeliveryStatusPickedUpWindow":
      return build(ChangePackageDeliveryStatusPickedUpForm, id, payload);

    case "RequestStockReservationWindow":
      return build(RequestStockReservationForm, id, payload);

    case "RequestShippingQuoteWindow":
      return build(RequestShippingQuoteForm, id, payload);

    case "AcceptShippingQuoteWindow":
      return build(AcceptShippingQuoteForm, id, payload);

    case "VoidShippingQuoteWindow":
      return build(VoidShippingQuoteForm, id, payload);

    case "NewCustomerWindow":
      return build(CreateCustomerForm, id, payload);

    case "ChangeContactDetailsWindow":
      return build(ChangeContactDetailsForm, id, payload);

    case "AddAccountWindow":
      return build(AddAccountForm, id, payload);

    case "DeleteAccountWindow":
      return build(DeleteAccountForm, id, payload);

    case "RenameAccountWindow":
      return build(RenameAccountForm, id, payload);

    case "AssignReferralCodeWindow":
      return build(AssignReferralCodeForm, id, payload);

    case "AssignAccountVipStatusWindow":
      return build(AssignAccountVipStatusForm, id, payload);

    case "UnassignAccountVipStatusWindow":
      return build(UnassignAccountVipStatusForm, id, payload);

    case "DeleteCustomerWindow":
      return build(DeleteCustomerForm, id, payload);


    case "ChangeBillingStatusWindow":
      return build(ChangeBillingStatusForm, id, payload);

    case "SubscriptionDeliveryWindow":
      return build(SubscriptionDeliveryView, id, payload);

    case "SubscriptionLogWindow":
      return build(SubscriptionLogView, id, payload);

    case "ChargePaymentsWindow":
      return build(ChargePaymentsView, id, payload);

    case "SetPaymentTermsWindow":
      return build(SetPaymentTermsForm, id, payload);

    case "SetPaymentCreditCardWindow":
      return build(SetPaymentCreditCardForm, id, payload);

    case "RecordPaymentWindow":
      return build(RecordPaymentForm, id, payload);

    case "CheckPaymentStatusWindow":
      return build(CheckPaymentStatusForm, id, payload);

    case "RetryPaymentWindow":
      return build(RetryPaymentForm, id, payload);

    case "ChangeSubscriptionFrequencyWindow":
      return build(ChangeSubscriptionFrequencyForm, id, payload);

    case "Change8PackPreferenceWindow":
      return build(Change8PackPreferenceForm, id, payload);

    case "ChangeSubscriptionQuantityWindow":
      return build(ChangeSubscriptionQuantityForm, id, payload);

    case "ChangeSubscriptionProductsWindow":
      return build(ChangeSubscriptionProductsForm, id, payload);

    case "ChangeSubscriptionShippingAddressWindow":
      return build(ChangeSubscriptionShippingAddressForm, id, payload);

    case "NewSubscriptionShippingAddressWindow":
      return build(NewSubscriptionShippingAddressForm, id, payload);

    case "RescheduleSubscriptionDeliveryWindow":
      return build(RescheduleSubscriptionDeliveryForm, id, payload);

    case "ResumeSubscriptionSchedulingWindow":
      return build(ResumeSubscriptionSchedulingForm, id, payload);

    case "PauseSubscriptionWindow":
      return build(PauseSubscriptionForm, id, payload);

    case "CancelSubscriptionWindow":
      return build(CancelSubscriptionForm, id, payload);

    case "RestartSubscriptionWindow":
      return build(RestartSubscriptionForm, id, payload);

    case "RenameSubscriptionWindow":
      return build(RenameSubscriptionForm, id, payload);

    case "AddCreditCardWindow":
      return build(AddCreditCardForm, id, payload);

    case "ChangeCreditCardWindow":
      return build(ChangeCreditCardForm, id, payload);

    case "RemoveCreditCardWindow":
      return build(RemoveCreditCardForm, id, payload);

    case "AssignDefaultCreditCardWindow":
      return build(AssignDefaultCreditCardForm, id, payload);

    case "ChangeCartPoliciesWindow":
      return build(ChangeCartPoliciesForm, id, payload);

    case "ToggleMarketingCommunicationsWindow":
      return build(ToggleMarketingCommunicationsForm, id, payload);

    case "AddShippingAddressWindow":
      return build(AddShippingAddressForm, id, payload);

    case "EditShippingAddressWindow":
      return build(EditShippingAddressForm, id, payload);

    case "RemoveShippingAddressWindow":
      return build(RemoveShippingAddressForm, id, payload);

    case "SetBillingAddressWindow":
      return build(SetBillingAddressForm, id, payload);

    case "ChangeBillingAddressWindow":
      return build(ChangeBillingAddressForm, id, payload);

    case "SetTaxInfoWindow":
      return build(SetTaxInfoForm, id, payload);

    case "SetTaxExemptionWindow":
      return build(SetTaxExemptionForm, id, payload);

    case "RecordWaterTestResultWindow":
      return build(RecordWaterTestResultForm, id, payload);

    case "RenameWarehouseWindow":
      return build(RenameWarehouseForm, id, payload);

    case "ChangeWarehouseAddressWindow":
      return build(WarehouseAddressForm, id, payload);

    case "ChangeWarehouseContactWindow":
      return build(WarehouseContactForm, id, payload);

    case "RegisterWarehouseWindow":
      return build(RegisterWarehouseForm, id, payload);

    case "AssignWarehouseCourierWindow":
      return build(AssignWarehouseCourierForm, id, payload);

    case "ChangeAvailabilityForLocationWindow":
      return build(ChangeAvailabilityForLocationForm, id, payload);

    case "AddStockWindow":
      return build(AddStockForm, id, payload);

    case "RemoveStockWindow":
      return build(RemoveStockForm, id, payload);

    case "CreateProductWindow":
      return build(CreateProductForm, id, payload);

    case "RemoveProductWindow":
      return build(RemoveProductForm, id, payload);

    case "ChangeProductDescriptionWindow":
      return build(ProductDescriptionForm, id, payload);

    case "ChangeProductBundleDescriptionWindow":
      return build(ProductBundleDescriptionForm, id, payload);

    case "CreateProductBundleWindow":
      return build(CreateProductBundleForm, id, payload);

    case "AddProductToBundleWindow":
      return build(AddProductToBundleForm, id, payload);

    case "RemoveProductFromBundleWindow":
      return build(RemoveProductFromBundleForm, id, payload);

    case "AddProductToShopWindow":
      return build(AddProductToShopForm, id, payload);

    case "RemoveProductFromShopWindow":
      return build(RemoveProductFromShopForm, id, payload);

    case "ChangeProductPricingWindow":
      return build(ChangeProductPricingForm, id, payload);

    case "ChangeSubscriptionProductPricingWindow":
      return build(ChangeSubscriptionProductPricingForm, id, payload);

    case "CommitProductPricelistWindow":
      return build(CommitProductPricelistForm, id, payload);

    case "CommitSubscriptionPricelistWindow":
      return build(CommitSubscriptionPricelistForm, id, payload);

    case "ApplyProductSurchargeWindow":
      return build(ApplyProductSurchargeForm, id, payload);

    case "EditProductSurchargeWindow":
      return build(EditProductSurchargeForm, id, payload);

    case "ChangeProductMeasurementsWindow":
      return build(MeasurementsForm, id, payload);

    case "SetOperationHoursWindow":
      return build(SetOperationHoursForm, id, payload);

    case "AssignWarehouseBackupWindow":
      return build(AssignWarehouseBackupForm, id, payload);

    case "ScanBarcodeWindow":
      return build(ScanBarcodeForm, id, payload);

    case "OrderDetailWindow":
      return build(OrderDetailForm, id, payload);

    case "AddProductToCartWindow":
      return build(AddProductToCartForm, id, payload);

    case "EditProductInCartWindow":
      return build(EditProductInCartForm, id, payload);

    case "AddSubscriptionToCartWindow":
      return build(AddSubscriptionToCartForm, id, payload);

    case "EditSubscriptionInCartWindow":
      return build(EditSubscriptionInCartForm, id, payload);


    case "RegisterOtherPalletWindow":
      return build(RegisterOtherPalletForm, id, payload);

    case "ModifyOtherPalletWindow":
      return build(ModifyOtherPalletForm, id, payload);

    case "RejectWaterContainerWindow":
      return build(RejectWaterContainerForm, id, payload);

    case "AddWaterContainerToPalletWindow":
      return build(AddWaterContainerToPalletForm, id, payload);


    case "SetAvailabilityWindow":
      return build(SetAvailabilityForm, id, payload);

    case "AssignWarehouseToLocationWindow":
      return build(AssignWarehouseToLocationForm, id, payload);

    case "ChangeWarehouseForOrderWindow":
      return build(ChangeWarehouseForOrderForm, id, payload);

    case "AssignWarehouseToOrderWindow":
      return build(AssignWarehouseToOrderForm, id, payload);


    case "StartDeliveryWindow":
      return build(StartDeliveryForm, id, payload);

    case "RetrySchedulingWindow":
      return build(RetrySchedulingForm, id, payload);

    case "RetryStockReservationWindow":
      return build(RetryStockReservationForm, id, payload);

    case "ChangeStockReservationWarehouseWindow":
      return build(ChangeStockReservationWarehouseForm, id, payload);

    case "ConsignmentCommandWindow":
      return build(ConsignmentCommandForm, id, payload);

    case "ConsignmentDetailsWindow":
      return build(ConsignmentDetailsForm, id, payload);

    case "CheckoutChangeShippingAddressWindow":
      return build(CheckoutChangeShippingAddressForm, id, payload);

    case "CheckoutEditShippingAddressWindow":
      return build(CheckoutEditShippingAddressForm, id, payload);

    case "CheckoutAddShippingAddressWindow":
      return build(CheckoutAddShippingAddressForm, id, payload);

    case "CheckoutAddGiftMessageWindow":
      return build(AddGiftMessageForm, id, payload);

    case "CheckoutEditGiftMessageWindow":
      return build(EditGiftMessageForm, id, payload);

    case "CheckoutRemoveGiftMessageWindow":
      return build(RemoveGiftMessageForm, id, payload);

    case "CancelCheckoutWindow":
      return build(CancelCheckoutForm, id, payload);      

    case "PlaceOrderWindow":
      return build(PlaceOrderForm, id, payload);

    case "CancelSalesOrderWindow":
      return build(CancelSalesOrderForm, id, payload);

    case "CreatePromoCodeWindow":
      return build(PromoCodeForm, id, payload);

    case "EditPromoCodeWindow":
      return build(EditPromoCodeForm, id, payload);

    case "MetaOrderHistoryWindow":
      return build(MetaOrderHistoryForm, id, payload);

    case "MetaOrderCancellationWindow":
      return build(MetaOrderCancellationForm, id, payload);

    case "MetaOrderRefundWindow":
      return build(MetaOrderRefundForm, id, payload);

    case "VoidChargeWindow":
      return build(VoidChargeForm, id, payload);

    case "CreateReferralCodeWindow":
      return build(CreateReferralCodeForm, id, payload);

    case "EditReferralCodeWindow":
      return build(EditReferralCodeForm, id, payload);


    case "StartServiceWindow":
      return build(StartServiceForm, id, payload);

    case "StopServiceWindow":
      return build(StopServiceForm, id, payload);

    case "RunServiceWindow":
      return build(RunServiceForm, id, payload);


    case "ChangeOnboardingPasswordWindow":
      return build(ChangePasswordForm, id, payload);

    case "InviteCustomerWindow":
      return build(InviteCustomerForm, id, payload);


    case "CreateNoteWindow":
      return build(CreateNoteForm, id, payload);

    case "EditNoteWindow":
      return build(EditNoteForm, id, payload);

    case "DeleteNoteWindow":
      return build(DeleteNoteForm, id, payload);


    case "ErrorWindow":
      return build(ErrorWindowView, id, payload);

    default:
      console.warn(`No builder found for window type "${kind}".`);
      return null;
  }
}

function build(cls, id, payload) {
  return React.createElement(cls, {key: id, id: id, ...payload});
}